import { configureStore } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import thunk from 'redux-thunk';

import ticketReducer from './ticket-service/ticketSlice';
import ticketShareReducer from './ticket-share-service/ticketShareSlice';
import userReducer from './user-service/userSlice';

const store = configureStore({
	reducer: {
		userRedux: userReducer,
		ticketRedux: ticketReducer,
		ticketShareReducer: ticketShareReducer,
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: false,
		}).prepend(thunk),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();

export default store;
